import React from 'react';
import { Button, Dropdown } from 'antd';
import { BlockOutlined, CloseCircleOutlined, DownCircleOutlined, EditOutlined } from '@ant-design/icons';
import { useHistory } from "react-router-dom";

const Action = ({ row, action, modalForm, modalDelete }) => {
    const history = useHistory();
    const items = [];

    if (!action.update && !action.delete && !action.detail) {
        return "-";
    }

    if (action.update) {
        items.push({
            key: '1',
            label: "Update",
            icon: <EditOutlined />,
            onClick: () => modalForm(true, row),
        });
    }

    if (action.delete) {
        items.push({
            key: '2',
            label: "Delete",
            icon: <CloseCircleOutlined />,
            onClick: () => modalDelete(true, row),
        });
    }

    if (action.detail) {
        items.push({
            key: '3',
            label: "Integration Module",
            icon: <BlockOutlined />,
            onClick: () => {
                // contoh redirect ke halaman lain
                history.push(`/configuration/integration-wa/module/${row.id}`);
            },
        });
    }

    return (
        <Dropdown
            trigger={['click']}
            menu={{ items }}
        >
            <Button type="primary">
                Opsi <DownCircleOutlined style={{ fontSize: 11 }} />
            </Button>
        </Dropdown>
    );
};

export default Action;
